<template>
  <div class="sidebar-toggle" :class="{'open': sideOpen}" @click="toggleSide()">
    <span></span>
    <span></span>
    <span></span>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'sidebar-toggle',
  computed: {
    ...mapFields({
      sideOpen: 'ui.dashSideOpen'
    })
  },
  methods: {
    toggleSide() {
      this.$store.commit('toggleDashSide')
    }
  }
}
</script>
